import {
  useCreateOrReadApp,
  useCreateAppVersion,
  useUploadAppVersionArchive,
  useDeployApp
} from "@/api";
import { useCallback } from "react";
import { CustomSubmit } from "../types/customSubmit.type";

type DeployVariables = {
  displayName: string;
  organizationSlug: string;
  appSlug: string;
  description: string;
  tarBlob: Blob;
};

export const useDeployLocalProject = () => {
  const createOrReadApp = useCreateOrReadApp();
  const [createAppVersion] = useCreateAppVersion();
  const uploadAppVersionArchive = useUploadAppVersionArchive();
  const [deployApp] = useDeployApp();

  const deploy = useCallback(
    async ({
      appSlug,
      displayName,
      organizationSlug,
      description,
      tarBlob
    }: DeployVariables): ReturnType<CustomSubmit> => {
      // TODO: Add proper error handling
      const app = await createOrReadApp({
        appSlug,
        organizationSlug,
        displayName,
        description
      });

      const appVersion = await createAppVersion({
        variables: { appId: app.id }
      });
      const appVersionId = appVersion.data?.appVersionCreate?.id;
      if (!appVersionId) throw new Error("App version not created");
      await uploadAppVersionArchive(appVersionId, tarBlob);

      const deployAppResponse = await deployApp({
        variables: { appVersionID: appVersionId }
      });
      if (deployAppResponse.errors) throw deployAppResponse.errors[0];
      if (!deployAppResponse.data?.appDeploy)
        throw new Error("Could not deploy the app");

      return {
        appId: app.id,
        appVersionId,
        deployVersionId: deployAppResponse.data.appDeploy.id
      };
    },
    [createOrReadApp, createAppVersion, uploadAppVersionArchive, deployApp]
  );

  return deploy;
};
